import React from 'react'
import OffLine from '../off-line'

const OffLinePl = () => {
    return <OffLine languageCode="pl" />
}

export default OffLinePl
